import autoload from "./autoload";
import auth from './mixins/auth';
import cart from './mixins/cart';
import initDom from './mixins/init_dom';

autoload();

window.app = new Vue({
  el: '#vue-coverage-calculator',
  mixins: [initDom, auth, cart],

  data() {
    return {
      isAdvancedCalc: false,

      //inputs
      milThickness: 0,
      costPerLb: 0,
      specificGravity: 0,
      transferEfficiency: 0,
      length: 0,
      width: 0,
      sqft: 0,

      //results
      lbsNeeded: '0',
      squareFt: '0.00',
      powderCoverage: '0.00',
      estCostPerSqft: '0.00',
      estCost: '0.00',
      estLbsNeeded: '0.00',
    }
  },

  computed: {
    coverageStatusClass() {
      if (this.squareFt === 'Please Enter Valid #\'s' || this.lbsNeeded === 'Please Enter Valid #\'s') {
        return 'bg-danger text-white';
      } else if (this.squareFt > 0 || this.lbsNeeded > 0) {
        return 'bg-success text-white';
      } else {
        return '';
      }
    },

    coverageStatusClassAdvPC() {
      if (this.powderCoverage === 'Please Enter Valid #\'s') {
        return 'bg-danger text-white';
      } else if (this.powderCoverage > 0) {
        return 'bg-success text-white';
      } else {
        return '';
      }
    },

    coverageStatusClassAdvCPSF() {
      if (this.estCostPerSqft === 'Please Enter Valid #\'s') {
        return 'bg-danger text-white';
      } else if (this.estCostPerSqft > 0) {
        return 'bg-success text-white';
      } else {
        return '';
      }
    },

    coverageStatusClassAdvCost() {
      if (this.estCost === 'Please Enter Valid #\'s') {
        return 'bg-danger text-white';
      } else if (this.estCost > 0) {
        return 'bg-success text-white';
      } else {
        return '';
      }
    },

    coverageStatusClassAdvLbs() {
      if (this.estLbsNeeded === 'Please Enter Valid #\'s') {
        return 'bg-danger text-white';
      } else if (this.estLbsNeeded > 0) {
        return 'bg-success text-white';
      } else {
        return '';
      }
    }
  },

  methods: {
    calculatePowderCoverage() {
      if(this.isAdvancedCalc) {
        this.powderCoverage = (192.3/this.specificGravity/this.milThickness*(this.transferEfficiency/100)).toFixed(2);
        this.estCostPerSqft = (this.costPerLb/this.powderCoverage).toFixed(2);
        this.estCost = (this.estCostPerSqft*this.sqft).toFixed(2);
        this.estLbsNeeded = (this.sqft/this.powderCoverage).toFixed(2);

          if (isNaN(this.powderCoverage) || this.powderCoverage === "Infinity") {
            this.powderCoverage = 'Please Enter Valid #\'s';
            this.estCostPerSqft = 'Please Enter Valid #\'s';
            this.estCost = 'Please Enter Valid #\'s';
            this.estLbsNeeded = 'Please Enter Valid #\'s';
          } else if (isNaN(this.estCost)) {
            this.estCost = 0;
          }

      } else {
        this.squareFt = ((this.length*this.width)/144).toFixed(2);
        this.lbsNeeded = (this.squareFt/20).toFixed(0);

        if (this.length <= 0 || this.width <= 0) {
          this.squareFt = 'Please Enter Valid #\'s';
          this.lbsNeeded = 'Please Enter Valid #\'s';
        }

        if (this.lbsNeeded <= .5) this.lbsNeeded = 1;
      }
    },

    resetForm() {
      this.milThickness = 0;
      this.costPerLb = 0;
      this.specificGravity = 0;
      this.transferEfficiency = 0;
      this.length = 0;
      this.width = 0;
      this.sqft = 0;
      this.lbsNeeded = '0';
      this.squareFt = '0.00';
      this.powderCoverage = '0.00';
      this.estCostPerSqft = '0.00';
      this.estCost = '0.00';
      this.estLbsNeeded = '0.00';
    },
  },
});